export default "__VITE_ASSET__BqVEyONu__"